export default {
    data: {
        swi: {
            img1: "//m.360buyimg.com/mobilecms/s750x750_jfs/t1/180974/9/6325/191463/60b0ab7fE67acf23b/28920955cc06fcfe.jpg!q80.dpg.webp",
            img2: "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/153457/35/9377/80509/5fd3300bEa14f6b0f/f60a95a9f1731200.jpg!q70.dpg.webp",
            img3: "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/141930/5/18182/85325/5fd346cfEc024158b/df6fe498b38221c1.jpg!q70.dpg.webp",
            img4: "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/149047/25/18194/49137/5fd346c5Ee424ff8d/ffcc4ee8cc62905f.jpg!q70.dpg.webp"
        }
    }
}